import { render } from "./InstallerCompleteScreen.vue?vue&type=template&id=a1f93144&scoped=true"
import script from "./InstallerCompleteScreen.vue?vue&type=script&lang=js"
export * from "./InstallerCompleteScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=a1f93144&lang=scss&scoped=true"
import "./InstallerCompleteScreen.vue?vue&type=style&index=1&id=a1f93144&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f93144"]])

export default __exports__